export const LINKS = {
  ARBISCAN: 'https://arbiscan.io/token/0x4305c4bc521b052f17d389c2fe9d37cabeb70d54',
  DISCORD: 'https://redrct.overlay.market/discord',
  DOCUMENTATION: 'https://docs.overlay.market/',
  GOVERNANCE: 'https://commonwealth.im/overlay',
  LANDING: 'https://overlay.market',
  MIRROR: 'https://mirror.xyz/0x7999C7f0b9f2259434b7aD130bBe36723a49E14e',
  RISKS: 'https://docs.overlay.market/Security/Risks',
  TELEGRAM: 'https://t.me/overlay_protocol',
  TWITTER: 'https://twitter.com/OverlayProtocol',
  STATISTICS: 'https://stats.overlay.market/',
}
